import { Component, EventEmitter, OnInit, Output, Input, HostListener, ElementRef, ViewChild, OnChanges, SimpleChanges } from '@angular/core';
import { Subject } from 'rxjs';
import { AnModalBreakpoint, AnModalSetting, BreakpointsEnum } from '../../models/an-modal-setting';


@Component({
  selector: 'an-modal-container',
  templateUrl: './an-modal-container.component.html',
  styleUrls: ['./an-modal-container.component.scss']
})
export class AnModalContainerComponent implements OnInit, OnChanges {

  currentBreakpoint!: BreakpointsEnum;
  @Output() onChangeBreakpoint = new EventEmitter<BreakpointsEnum>();
  @Output() onClose = new EventEmitter();
  @Input() open = false;
  @Input() setting!: AnModalSetting;

  defaultSetting: AnModalSetting = {
    sm: {
      closeIconMargin: {
        top: '15px',
        right: '15px'
      },
      fullScreen: true,
      borderRadius: '0px',
      boxShadow: 'none'
    },
    md: {
      closeIconMargin: {
        top: '20px',
        right: '20px'
      },
      fullScreen: false,
      borderRadius: '10px',
      boxShadow: '0px 5px 10px #5C5C5C29'
    },
    lg: {
      closeIconMargin: {
        top: '20px',
        right: '20px'
      },
      fullScreen: false,
      borderRadius: '10px',
      boxShadow: '0px 5px 10px #5C5C5C29'
    },
    xl: {
      closeIconMargin: {
        top: '20px',
        right: '20px'
      },
      fullScreen: false,
      borderRadius: '10px',
      boxShadow: '0px 5px 10px #5C5C5C29'
    },
    scrolling: false,
    closing: {
      esc: true,
      backdrop: true
    },
    backdropColor: 'rgba(0, 0, 0, 0.7)'
  };

  @ViewChild('close') close!: ElementRef;

  modalBreakPointStyle!: AnModalBreakpoint;
  modalHeight = '100%';

  constructor(private ref: ElementRef) { }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.open) {
      if (changes.open.currentValue) {
        this.toggleScrollbar('hidden');
      } else {
        this.closeModal();
      }
    }
  }

  ngOnInit(): void {
    if (!this.setting) {
      this.setting = this.defaultSetting;
    } else {
      this.setting = { ...this.defaultSetting, ...this.setting };
    }

    console.log('an-modal-container setting...', this.setting);
    this.resize();
  }

  onClickHandle(e: Event) {
    if (this.setting.closing?.backdrop) {
      const el = (e.target as Element);
      if (el.nodeName === 'DIV') {
        if (el.className === 'an-modal') {
          this.closeModal();
        }
      }
    }
  }

  closeModal() {
    this.toggleScrollbar('auto');
    this.open = false;
    this.onClose.emit(true);
  }

  toggleScrollbar(state: string) {
    document.documentElement.style.overflow = state;
    document.body.style.touchAction = state === 'hidden' ? 'none' : state;
  }

  @HostListener('document:keydown.escape', ['$event'])
  onKeydownHandler(event: KeyboardEvent) {
    if (this.setting.closing?.esc) {
      this.closeModal();
    }
  }

  @HostListener('window:resize')
  resize() {
    if (window.innerWidth < 768) {
      this.setCurrentBreakpoint(BreakpointsEnum.sm);
      this.modalHeight = window.innerHeight + 'px'; 
    } else if (window.innerWidth >= 768 && window.innerWidth < 1024) {
      this.setCurrentBreakpoint(BreakpointsEnum.md);
      this.modalHeight = '100%';
    } else if (window.innerWidth >= 1024 && window.innerWidth < 1440) {
      this.setCurrentBreakpoint(BreakpointsEnum.lg);
    } else {
      this.setCurrentBreakpoint(BreakpointsEnum.xl);
    }
  }

  setCurrentBreakpoint(breackpoint: BreakpointsEnum) {
    if (this.currentBreakpoint != breackpoint) {
      this.currentBreakpoint = breackpoint;
      this.setStyles(breackpoint);
      this.onChangeBreakpoint.emit(breackpoint);
    }
  }

  setStyles(bp: BreakpointsEnum) {
    const bpStyle = this.setting[bp];
    if (bpStyle) {
      this.modalBreakPointStyle = bpStyle;
    }
  }


}
